module.exports = function (fox) {
	'use strict';
	fox.registerWidget('Page_CCPA_MC', {
		configure() {
			this.registerOptions('', {
				widgets: {
					popup: {
						widget: 'Dialog',
						useUiPosition: true,
						dialog: {
							title: 'California Consumer Privacy form',
							width: '550px',
							closeText: 'X',
							'!dialogClass': 'ccpa-form mc-xxx-common-popup',
						},
						widgets: {
							content: {
								widget: 'CCPR_Form',
								template: 'ccpa_form_mc',
							}
						}
					},
					popupSuccess: {
						widget: 'Dialog',
						useUiPosition: true,
						dialog: {
							title: 'Success',
							width: '340px',
							'!dialogClass': 'ccpa-form mc-xxx-common-popup',
						},
						widgets: {
							content: {
								widget: 'Widget',
								template: 'ccpa_success_mc',
								handleDom: {
									closePopup: {
										target: '#success',
										event: 'click',
										callback : '@parent @parent:successHide'
										
									}
								}
							}
						}
					}
				},
				handleWom: {
					success: {
						widget: '#popup #content',
						event: 'form_submit_success',
						callback: 'hidePopup',
					}
				}
			});
			this.callParent('configure', arguments);
		},
		successHide(){
			this.wom1('#popupSuccess').hide();
		},
		showPopup() {
				this.wom1('#popup').show();
		},
		hidePopup() {
			this.wom1('#popup').hide();
			this.wom1('#popupSuccess').show();
		},
	}, 'Page_CCPA');
};



// WEBPACK FOOTER //
// ./widget/ccpa.es.js